import { useTranslate } from '@refinedev/core';
import { Divider, Form, Input } from 'antd';
import { ImageKind } from '@/api/generated/schemas';
import { ImageUploadField } from './ImageUploadField';

interface Props {
  /** Current cover URL (edit forms — `record?.cover_url`). */
  coverUrl?: string | null;
  /** Current banner URL (edit forms — `record?.banner_url`). */
  bannerUrl?: string | null;
  /** Disable both uploads (e.g. system-managed records). */
  disabled?: boolean;
}

/**
 * Cover + banner uploads shared by every collection tab in `user_catalog`.
 * The storage keys are kept in hidden fields and filled by the upload
 * callbacks, so the form submits `*_storage_key` while the UI shows the image.
 */
export const CollectionImageFields = ({
  coverUrl,
  bannerUrl,
  disabled,
}: Props) => {
  const t = useTranslate();
  const form = Form.useFormInstance();

  return (
    <>
      <Divider>{t('base.sections.graphics')}</Divider>

      <Form.Item name="cover_storage_key" hidden>
        <Input />
      </Form.Item>
      <ImageUploadField
        imageKind={ImageKind.collection_covers}
        currentUrl={coverUrl}
        disabled={disabled}
        onUpload={(key) => form.setFieldsValue({ cover_storage_key: key })}
        label={t('base.collection.cover_url')}
      />

      <Form.Item name="banner_storage_key" hidden>
        <Input />
      </Form.Item>
      <ImageUploadField
        imageKind={ImageKind.collection_banners}
        currentUrl={bannerUrl}
        disabled={disabled}
        onUpload={(key) => form.setFieldsValue({ banner_storage_key: key })}
        label={t('base.collection.banner_url')}
      />
    </>
  );
};
